import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Adoption.css";
import { useNavigate } from "react-router-dom";

const Adoption = () => {
  const navigate = useNavigate();


  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  return (
    <>
     <section className="services-page">

  {/* Banner */}
  <div className="service-banner">
    <div className="overlay"></div>
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <h1>Services</h1>
          <p>Find Love That Lasts - Adopt, Don't Shop</p>
        </div>

        <div className="col-lg-6 text-end">
          <img
            src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
            alt="Pets"
            className="img-fluid banner-pets"
          />
        </div>
      </div>
    </div>
  </div>

  {/* Adoption Card */}
  <div className="adoption-section">
    <div className="container">

      <div className="adoption-card">

        <div className="row align-items-center">

          <div className="col-lg-5">
            <h2>
              Adoption <span>(View All)</span>
            </h2>

            <p className="Adoption_info">Information</p>

            <p className="Adoption_info">Name - Bubble</p>
            <p className="Adoption_info">Age - 5</p>

            <button className="btn adopt-btn">
              Call to Adopt
            </button>

            <h4 className="phone-no">
              Call 9892145670
            </h4>
          </div>

          <div className="col-lg-7">
            <div className="dog-image-wrap">
              <img
                src={`${process.env.PUBLIC_URL}/assets/imgs/adoption.png`}
                alt="Dog"
                className="img-fluid dog-image"
              />
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>

  {/* Content */}
  <div className="adoption-guide">
    <div className="container">

      <h2>Steps to Take care while adoption</h2>

      <p className="guide-desc">
        Adopting a dog is a wonderful and rewarding experience,
        but it also comes with responsibilities.
        Here's a comprehensive checklist of steps to take care
        of your new dog after adoption:
      </p>

      <h3>Immediate Steps (First Few Days)</h3>

      <div className="row mt-5">

        <div className="col-lg-6 pe-lg-5">

          <div className="guide-box">
            <h4>Prepare your home:</h4>
            <ul>
              <li>Dog bed, bowls, leash, collar, ID tag, toys and food.</li>
              <li>Puppy-proof your space.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Visit the Veterinarian:</h4>
            <ul>
              <li>Schedule a health check-up.</li>
              <li>Check vaccination and deworming.</li>
              <li>Discuss overall health.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Give Time to Adjust:</h4>
            <ul>
              <li>Allow your dog to explore.</li>
              <li>Keep it quiet and stress-free.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Establish a Routine:</h4>
            <ul>
              <li>Set meal and walk timings.</li>
              <li>Routine builds trust.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Nutrition & Feeding:</h4>
            <ul>
              <li>Use familiar food initially.</li>
              <li>Transition gradually.</li>
              <li>Ensure fresh water.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Potty Training & House Rules:</h4>
            <ul>
              <li>Take them to the same potty spot.</li>
              <li>Reward good behaviour.</li>
              <li>Be consistent.</li>
            </ul>
          </div>

        </div>

        <div className="col-lg-6 ps-lg-5 border-start border-dark">

          <div className="guide-box">
            <h4>Exercise & Mental Stimulation:</h4>
            <ul>
              <li>Daily walks.</li>
              <li>Playtime and activities.</li>
              <li>Social interaction.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Comfort & Safe Space:</h4>
            <ul>
              <li>Provide a comfortable bed.</li>
              <li>Create a safe retreat area.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Training & Behavior:</h4>
            <ul>
              <li>Basic commands.</li>
              <li>Positive reinforcement.</li>
              <li>Enroll in obedience classes.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Legal Requirements:</h4>
            <ul>
              <li>Get licensed if required.</li>
              <li>Update tags and microchip info.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Bonding & Love:</h4>
            <ul>
              <li>Spend quality time together.</li>
              <li>Be patient while settling.</li>
            </ul>
          </div>

          <div className="guide-box">
            <h4>Emergency Preparedness:</h4>
            <ul>
              <li>Know the nearest emergency vet.</li>
              <li>Keep a pet first-aid kit.</li>
            </ul>
          </div>

        </div>

      </div>

    </div>
  </div>

</section>
    </>
  );
};

export default Adoption;
